import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cab48c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "body"
}
const _hoisted_4 = {
  class: "table table-fixed table-striped",
  style: {"max-width":"720px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Giorno", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = {
  class: "table table-fixed table-striped",
  style: {"max-width":"720px"}
}
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = {
  class: "table table-fixed table-striped",
  style: {"max-width":"720px"}
}
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_32 = { class: "mt-5 mw-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_address = _resolveComponent("op-address")!
  const _component_accordion = _resolveComponent("accordion")!
  const _directive_date = _resolveDirective("date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Gestione orari prenotazione",
          text: "Gestione orari prenotazione"
        })
      ])
    ]),
    (_ctx.config)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_op_address, {
              modelValue: _ctx.config.address,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.address) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Orari della settimana",
                  text: "Orari della settimana"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.orariPrenotazione.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Giorno",
                        text: "Giorno"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Slot orari",
                        text: "Slot orari"
                      }),
                      _hoisted_5,
                      _createVNode(_component_localized_text, {
                        localizedKey: "(selezionabili per appuntamento)",
                        text: "(selezionabili per appuntamento)"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addOrarioPrenotazione && _ctx.addOrarioPrenotazione(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.orariPrenotazione, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((item.giornoSettimana) = $event)
                        }, [
                          _hoisted_8,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (i, day) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: i,
                              value: i
                            }, _toDisplayString(day), 9, _hoisted_9))
                          }), 128))
                        ], 8, _hoisted_7), [
                          [_vModelSelect, item.giornoSettimana]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success",
                            onClick: ($event: any) => (_ctx.addFasciaOraria(item))
                          }, "+", 8, _hoisted_11)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fasceOrarie, (fascia, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex align-items-center justify-content-around",
                            key: i
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              "onUpdate:modelValue": ($event: any) => ((fascia.from) = $event)
                            }, null, 8, _hoisted_12), [
                              [_vModelText, fascia.from]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              "onUpdate:modelValue": ($event: any) => ((fascia.to) = $event)
                            }, null, 8, _hoisted_13), [
                              [_vModelText, fascia.to]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (_ctx.removeFascia(fascia, item.fasceOrarie))
                            }, "-", 8, _hoisted_14)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.removeOrarioPrenotazione(item))
                        }, "- rimuovi giorno", 8, _hoisted_16)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _hoisted_17,
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Giorni da escludere",
                  text: "Giorni da escludere"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.giorniDaEscludere.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_18, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Giorno",
                        text: "Giorno"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Mese",
                        text: "Mese"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addGiornoDaEscludere && _ctx.addGiornoDaEscludere(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.giorniDaEscludere, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "Giorno (numero)",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.giorno) = $event)
                        }, null, 8, _hoisted_20), [
                          [_vModelText, item.giorno]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "Mese (numero)",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.mese) = $event)
                        }, null, 8, _hoisted_21), [
                          [_vModelText, item.mese]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.config.giorniDaEscludere.splice(i, 1))
                        }, "-", 8, _hoisted_23)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _hoisted_24,
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Periodi da escludere",
                  text: "Periodi da escludere"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.periodiDaEscludere.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_25, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Inizio",
                        text: "Inizio"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Fine",
                        text: "Fine"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addPeriodoDaEscludere && _ctx.addPeriodoDaEscludere(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.periodiDaEscludere, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.from) = $event)
                        }, null, 8, _hoisted_27), [
                          [_directive_date, item.from],
                          [_vModelText, item.from]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.to) = $event)
                        }, null, 8, _hoisted_28), [
                          [_directive_date, item.to],
                          [_vModelText, item.to]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.config.periodiDaEscludere.splice(i, 1))
                        }, "-", 8, _hoisted_30)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-block btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "OK",
                text: "OK"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}